/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Save_New_LabelInputs */

const en_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save new metadata`)
};

const fr_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer de nouvelles métadonnées`)
};

const de_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Metadaten speichern`)
};

const it_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva nuovi metadati`)
};

const ru_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить новые метаданные`)
};

const es_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar nuevos metadatos`)
};

const zh_cn2_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存新元数据`)
};

const ja_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいメタデータを保存`)
};

const hi_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मेटाडेटा सहेजें`)
};

const pt_pt2_event_group_metadata_save_new_label = /** @type {(inputs: Event_Group_Metadata_Save_New_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar novos metadados`)
};

/**
* | output |
* | --- |
* | "Save new metadata" |
*
* @param {Event_Group_Metadata_Save_New_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_save_new_label = /** @type {((inputs?: Event_Group_Metadata_Save_New_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Save_New_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_save_new_label(inputs)
	if (locale === "de") return de_event_group_metadata_save_new_label(inputs)
	if (locale === "it") return it_event_group_metadata_save_new_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_save_new_label(inputs)
	if (locale === "es") return es_event_group_metadata_save_new_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_save_new_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_save_new_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_save_new_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_save_new_label(inputs)
	return en_event_group_metadata_save_new_label(inputs)
});